import Vue from 'vue'
import Vuex from 'vuex'
import Vuer from 'vue-router'
import Vuel from 'vue-tel-input'
import Vuet from 'vue-toasted'
import App from './App.vue'
import https from './http'
import routes from './route'
import stores from './store'
import 'bootstrap'

Vue.use(Vuex);
Vue.use(Vuer);
Vue.use(Vuet, {duration: 5000, action: {icon : 'bell',onClick:(_e,t)=>t.goAway(0)}, iconPack: 'fontawesome', theme: 'bubble'});

Vue.config.productionTip = false;
const store = new Vuex.Store(stores), router = new Vuer(routes);
router.beforeEach((to, _, next) => {
  if(to.matched.some(_=>_.meta.auth)) 
    if(store.getters.isLogged)
      store.getters.loggedAs.active ? next() : next((to.name === 'ross' || to.name === 'profile') ? {replace: true} : {name: 'profile'})
    else next({name: 'home'});
  else next();
});
https.interceptors.response.use(undefined, err => {
  let { response } = err; //this.$toasted.error(response.data.error_description, {icon : 'bug'});//if(!err.config.hasOwnProperty('handlerr') && !error.config.handlerr) 
  if (response) {
    if(response.status === 401 && response.config && !response.config.__isRetryRequest) 
      store.dispatch('logout').then(() => router.push({name:'home'}));
    return Promise.reject(response);
  } else return Promise.reject(err);
});
Vue.component('vue-tel-input', Vuel);
Vue.component('modal', {
  props: {
    value: String,
  },
  methods: {
    onClose() {
      $(`#${this.value}`).modal('hide') //this.$emit('close', this.value);
    }
  },
  template: `
  <div class="modal fade" :id="value" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title"><slot name="header"></slot></div>
          <button type="button" class="close" data-dismiss="modal" @click="onClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body"><slot></slot></div>
        <div class="modal-footer"><slot name="footer"></slot></div>
      </div>
    </div>
  </div>
  `
});
Vue.component('loader', {
  template: `
  <div class="d-flex justify-content-center">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>`
});
Vue.filter('currency', money => money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));

window.api = https; window.api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');